import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Container,
  Breadcrumbs,
  Link,
} from '@mui/material';
import { Description as ResumeIcon } from '@mui/icons-material';

export const ResumeExport = () => {
  const [includeSummary, setIncludeSummary] = useState('no');
  const [includeSkills, setIncludeSkills] = useState('no');
  const [keepAddressPrivate, setKeepAddressPrivate] = useState('yes');

  const handleDownload = () => {
    // TODO: Implement resume download functionality
    console.log('Downloading resume with settings:', {
      includeSummary,
      includeSkills,
      keepAddressPrivate,
    });
  };

  const handleSaveSettings = () => {
    // TODO: Implement save settings functionality
    console.log('Saving settings:', {
      includeSummary,
      includeSkills,
      keepAddressPrivate,
    });
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs sx={{ mb: 3 }}>
        <Link 
          color="inherit" 
          href="/services" 
          sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
        >
          Services
        </Link>
        <Typography color="text.primary">Resume Export</Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
          Resume Export
        </Typography>
      </Box>

      {/* Main Content Card */}
      <Card sx={{ mb: 4, boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)' }}>
        <CardContent sx={{ p: 4 }}>
          {/* Service Description */}
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
              Create your professional, driver-specific resume
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '600px', mx: 'auto' }}>
              Resume Export is a free service that uses your DriverVerified profile to instantly
              generate a professional, driver-specific resume.
            </Typography>
          </Box>

          {/* Form Options */}
          <Box sx={{ maxWidth: '500px', mx: 'auto' }}>
            {/* Opening Summary Option */}
            <FormControl component="fieldset" sx={{ mb: 3, width: '100%' }}>
              <FormLabel component="legend" sx={{ mb: 2, fontWeight: 600, color: 'text.primary' }}>
                Include an opening summary?
              </FormLabel>
              <RadioGroup
                value={includeSummary}
                onChange={(e) => setIncludeSummary(e.target.value)}
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio />}
                  label="Yes - I want to write something about myself"
                />
                <FormControlLabel
                  value="no"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>

            {/* Skills Summary Option */}
            <FormControl component="fieldset" sx={{ mb: 3, width: '100%' }}>
              <FormLabel component="legend" sx={{ mb: 2, fontWeight: 600, color: 'text.primary' }}>
                Include a skills summary?
              </FormLabel>
              <RadioGroup
                value={includeSkills}
                onChange={(e) => setIncludeSkills(e.target.value)}
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio />}
                  label="Yes - I want to list my skills"
                />
                <FormControlLabel
                  value="no"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>

            {/* Address Privacy Option */}
            <FormControl component="fieldset" sx={{ mb: 4, width: '100%' }}>
              <FormLabel component="legend" sx={{ mb: 2, fontWeight: 600, color: 'text.primary' }}>
                Keep your street address private?
              </FormLabel>
              <RadioGroup
                value={keepAddressPrivate}
                onChange={(e) => setKeepAddressPrivate(e.target.value)}
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="no"
                  control={<Radio />}
                  label="No - Show my full address"
                />
              </RadioGroup>
            </FormControl>

            {/* Action Buttons */}
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button
                variant="outlined"
                onClick={handleSaveSettings}
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                Save Settings
              </Button>
              <Button
                variant="contained"
                onClick={handleDownload}
                startIcon={<ResumeIcon />}
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 600,
                  backgroundColor: '#1976d2',
                  '&:hover': {
                    backgroundColor: '#1565c0',
                  },
                }}
              >
                Download Resume
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}; 